import { render, staticRenderFns } from "./import-citizenship-statistic.vue?vue&type=template&id=57d4b25c&"
import script from "./import-citizenship-statistic.vue?vue&type=script&lang=js&"
export * from "./import-citizenship-statistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports